import { gql } from '@apollo/client';

export default gql`
  mutation removePreferencesKeyword($input: String!) {
    removeBuyerPreferencesKeyword(input: $input)
  }
`;
